module.exports = __webpack_public_path__ + "img/notification.7c5cd674.svg";